


import React, { useState, useRef, useEffect } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RefreshIcon from '@mui/icons-material/Refresh';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import styles from './AiChatBot.module.css';
import { analyzeBandwidth, analyzeVisualization, detectIntent, fetchCustomerById, fetchLocationForVendor, fetchLocations, fetchVendorsForLocation, processQueryWithEnhancedContext, sendFeedback } from './AiAPI/api';
import LocationSelector from './location/LocationSelector';
import VendorSelector from './vendor/VendorSelector';
import TimePeriodSelector from './timeperiod/TimePeriodSelector';
import BotResultView from './result/BotResultView';



const authToken = "Fil0ff56@9090";
const customerId = "110";
const DEFAULT_SESSION_ID = `session_${Math.random().toString(36).slice(2, 10)}`;


const AiChatBot = () => {
    const alphaSort = arr => [...arr].sort((a, b) => a.localeCompare(b));
  const [messages, setMessages] = useState([
    {
      sender: 'bot',
      text: "Welcome! I'm your dedicated Network Query Agent. Ask about network status, uptime, or alerts.",
      timestamp: new Date(),
    },
  ]);
  const [input, setInput] = useState('');
//   const [expandedIndexes, setExpandedIndexes] = useState([]);
const [expandedIndexes, setExpandedIndexes] = useState([messages.length - 1]);

  const [isThinking, setIsThinking] = useState(false); 
  const [showAgentBadgeIdx, setShowAgentBadgeIdx] = useState(null);
const [sessionId, setSessionId] = useState(DEFAULT_SESSION_ID);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedCircuitLocation, setSelectedCircuitLocation] = useState("");
const [selectedCircuitVendor, setSelectedCircuitVendor] = useState("");
const [selectedCircuitId, setSelectedCircuitId] = useState("");
const [selectedQuarter, setSelectedQuarter] = useState("");
const [showNewChatButton, setShowNewChatButton] = useState(false);



const quarters = [
  { label: "Q1 2025", start: new Date(2025, 0, 1), end: new Date(2025, 2, 31) },
  { label: "Q2 2025", start: new Date(2025, 3, 1), end: new Date(2025, 5, 30) },
  // Add more as needed
];

  const chatBodyRef = useRef(null);

  useEffect(() => {
    chatBodyRef.current?.scrollTo(0, chatBodyRef.current.scrollHeight);
  }, [messages]);

  function getLastUserMessage(msgs) {
  for (let i = msgs.length - 1; i >= 0; i-1) {
    if (msgs[i].sender === 'user') return msgs[i].text;
  }
  return '';
}



function mapProvidedParams(provided = {}) {
  let selectedLocations = [];
  if (provided.location) {
    selectedLocations = Array.isArray(provided.location)
      ? provided.location
      : [provided.location];
  }
  let selectedVendors = [];
  if (provided.vendor) {
    selectedVendors = Array.isArray(provided.vendor)
      ? provided.vendor
      : [provided.vendor];
  }
  const selectedTimePeriod = provided.time_period || "";
  return { selectedLocations, selectedVendors, selectedTimePeriod };
}



const getFinalQueryString = (userQuery, params) => {
  const lcUserQuery = userQuery.toLowerCase();

const arrayOrEmpty = val => {
  if (Array.isArray(val)) {
    return val.filter(Boolean);
  }
  if (typeof val === 'string' && val.trim()) {
    return [val.trim()];
  }
  return [];
};


  const locationsArr = arrayOrEmpty(params.selectedLocations || params.locations);
  const vendorsArr = arrayOrEmpty(params.selectedVendors || params.vendors);
  const timeArr = arrayOrEmpty(params.selectedTimePeriod || params.time_period);

  const parts = [userQuery];

  const addIfMissing = (arr) => 
    arr.filter(val => !lcUserQuery.includes(val.toLowerCase()))
       .join(', ');

  const locsToAdd = addIfMissing(locationsArr);
  if (locsToAdd) parts.push(locsToAdd);

  const vensToAdd = addIfMissing(vendorsArr);
  if (vensToAdd) parts.push(vensToAdd);

  const timeToAdd = addIfMissing(timeArr);
  if (timeToAdd) parts.push(timeToAdd);

  return parts.filter(Boolean).join(" for ");
};



// Parameter fetcher object (outside of handleSend but inside the component)
const paramFetchers = {
 location: async ({ vendor, authToken }) => {
  if (vendor) {
    const resp = await fetchLocationForVendor({ vendor, authToken , customerId});
    console.log("fetchLocationForVendor resp:", resp);
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;
    if (Array.isArray(resp.locations)) return resp.locations;
    return [];
  }
  const resp = await fetchLocations({ authToken, customerId });

  if (Array.isArray(resp)) return resp;
  if (Array.isArray(resp.locations)) return resp.locations;
  return [];
},
  vendor: async ({ location, authToken }) => {
    if (location) {
      const resp = await fetchVendorsForLocation({ location, authToken, customerId });
      return resp || [];
    }
    return [];
  }
  
};

const handleIntentRouting = async (intentResult, params, trimmed) => {
  // GREETING INTENT: show only suggested response
  if (intentResult.intent === 'greeting') {
    setMessages(prev => [
      ...prev,
      {
        sender: 'bot',
        text: intentResult.suggested_response,
        timestamp: new Date()
      }
    ]);
    setIsThinking(false);
    return;
  }

  // Collect list of required params from detect-intent response
  const paramsNeeded = intentResult.parameters_needed || [];
  const allParamsFilled = paramsNeeded.every(param => {
    if (param === 'location') return params.selectedLocations.length > 0;
    if (param === 'vendor') return params.selectedVendors.length > 0;
    if (param === 'time_period') return !!params.selectedTimePeriod;
    return false;
  });

  // NETWORK QUERY INTENT: only run analytics if all params present!
  if (intentResult.intent === 'network_query') {
    if (allParamsFilled) {
      await handleFinalQuery(trimmed, params);
      setIsThinking(false);
      return;
    }
    // Otherwise start parameter selection flow
    await handleMissingParamsRecursive({
      paramsNeeded,
      params,
      intentResult,
      userQuery: trimmed
    });
    // handleMissingParamsRecursive will manage isThinking
    return;
  }

  // RECOMMENDATION INTENT: show prompt,
  // then run fetchCustomerById if all params present
if (intentResult.intent === 'recommendation') {

  setIsThinking(true);
  try {
    // 1. Fetch customer circuits
    const customerInfo = await fetchCustomerById({
      customerId,
      authToken
    });

    const circuits = customerInfo.circuits || [];
    if (!circuits.length) {
      setIsThinking(false);
      setMessages(prev => [
        ...prev,
        {
          sender: 'bot',
          text: "No circuits found for this customer.",
          timestamp: new Date()
        }
      ]);
      return;
    }

    // 2. Trigger multi-step selection: let user pick location, vendor, circuit, time
    setMessages(prev => [
      ...prev,
      {
        sender: 'bot',
        text: intentResult.suggested_response,
        circuits,
        recommendationStep: true, // flag, see below
        timestamp: new Date()
      }
    ]);
    setIsThinking(false);
    return;
  } catch (err) {
    setIsThinking(false);
    setMessages(prev => [
      ...prev,
      {
        sender: 'bot',
        text: "Sorry, couldn't fetch customer circuit details.",
        timestamp: new Date()
      }
    ]);
    return;
  }
}





  // DEFAULT: just show suggested response
  setMessages(prev => [
    ...prev,
    {
      sender: 'bot',
      text: intentResult.suggested_response || 'How can I assist you?',
      timestamp: new Date()
    }
  ]);
  setIsThinking(false);
};







const handleSend = async (e, userTriggeredInput) => {
  if (e) e.preventDefault();
  const trimmed = (userTriggeredInput !== undefined ? userTriggeredInput : input.trim());
  if (!trimmed) return;

  setMessages([
    ...messages,
    { sender: 'user', text: trimmed, timestamp: new Date() }
  ]);
  setInput('');
  setIsThinking(true);

  try {
    const intentResult = await detectIntent({
      message: trimmed,
      authToken,
      customerId,
      sessionId
    });

    const params = mapProvidedParams(intentResult.parameters_provided);

    await handleIntentRouting(intentResult, params, trimmed);

  } catch (err) {
    setIsThinking(false);
    setMessages(msgs => [
      ...msgs,
      {
        sender: 'bot',
        text: 'Sorry, there was a problem contacting the AI Agent.',
        timestamp: new Date()
      }
    ]);
  }
};

async function handleMissingParamsRecursive({ paramsNeeded, params, intentResult, userQuery }) {
  const next = paramsNeeded.find(param => {
    if (param === 'location') return params.selectedLocations.length === 0;
    if (param === 'vendor') return params.selectedVendors.length === 0;
    if (param === 'time_period') return !params.selectedTimePeriod;
    return false;
  });

  if (!next) {
    await handleFinalQuery(userQuery, params);
    setIsThinking(false);
    return;
  }

  let options = [];
  if (next === 'location') {
    options = await paramFetchers.location({ vendor: params.selectedVendors[0], authToken });
  } else if (next === 'vendor') {
    options = await paramFetchers.vendor({ location: params.selectedLocations[0], authToken });
  }

  setIsThinking(false);

  setMessages(prev => [
    ...prev,
    {
      sender: "bot",
      text: intentResult.suggested_response || `Please select ${next.replace('_', ' ')}.`,
      paramOptions: { [next]: options.length > 0 ? options : true }, // true for time_period triggers selector
      pendingParam: next,
      selectedLocations: params.selectedLocations,
      selectedVendors: params.selectedVendors,
      selectedTimePeriod: params.selectedTimePeriod,
      userQuery,
      context: intentResult,
      timestamp: new Date()
    }
  ]);
}
const handleParamSelection = async (msg, paramName, value) => {
  const updatedParams = {
    selectedLocations: msg.selectedLocations || [],
    selectedVendors: msg.selectedVendors || [],
    selectedTimePeriod: msg.selectedTimePeriod || ""
  };
  if (paramName === "location") updatedParams.selectedLocations = Array.isArray(value) ? value : [value];
  if (paramName === "vendor") updatedParams.selectedVendors = Array.isArray(value) ? value : [value];
  if (paramName === "time_period") updatedParams.selectedTimePeriod = value;

  setIsThinking(true);
  setMessages(prev => {
    const msgs = [...prev];
    const idx = msgs.indexOf(msg);
    if (idx !== -1) {
      msgs[idx].selectedLocations = updatedParams.selectedLocations;
      msgs[idx].selectedVendors = updatedParams.selectedVendors;
      msgs[idx].selectedTimePeriod = updatedParams.selectedTimePeriod;
      delete msgs[idx].paramOptions;
    }
    return msgs;
  });

  const paramsNeeded = msg.context.parameters_needed || [];
  await handleMissingParamsRecursive({
    paramsNeeded,
    params: updatedParams,
    intentResult: msg.context,
    userQuery: msg.userQuery
  });
};




// const handleFinalQuery = async (userQuery, params) => {
//   setIsThinking(true);
//   const finalQuery = getFinalQueryString(userQuery, params);

//   try {
   
//     const processResult = await processQueryWithEnhancedContext({
//       query: finalQuery,
//       customerId,
//       authToken,
//       locations: params.selectedLocations,
//       vendors: params.selectedVendors,
//       timePeriod: params.selectedTimePeriod,
//     });

//     let vizResult = null;
//     let vizError = false;

//     try {
    
//       vizResult = await analyzeVisualization({
//         query: finalQuery,
//         sqlQuery: processResult.gemini.query,
//         csvData: processResult.gemini.csv,
//         customerId,
//         authToken,
//       });
//     } catch {
//       vizError = true;
//     }

//     setMessages(prev => [
//       ...prev,
//       {
//         sender: 'bot',
//         text: vizError
//           ? 'Query executed. (Visualization unavailable)'
//           : "Query executed with analysis and visualization.",
//         resultPayload: {
//           ...processResult,
//           ...(vizResult ? { visualization: vizResult } : {}),
//         },
//         timestamp: new Date(),
//       }
//     ]);
//     setShowNewChatButton(true);
//   } catch {
//     setMessages(prev => [
//       ...prev,
//       {
//         sender: 'bot',
//         text: 'Could not process query. Please try again.',
//         timestamp: new Date()
//       }
//     ]);
//   }
//   setIsThinking(false);
//   setShowNewChatButton(true);
// };

const handleFinalQuery = async (userQuery, params) => {
  setIsThinking(true);
  const finalQuery = getFinalQueryString(userQuery, params);

  try {
    const processResult = await processQueryWithEnhancedContext({
      query: finalQuery,
      customerId,
      authToken,
      locations: params.selectedLocations,
      vendors: params.selectedVendors,
      timePeriod: params.selectedTimePeriod,
    });

    // Visualization analysis is removed from here.

    setMessages(prev => [
      ...prev,
      {
        sender: 'bot',
        text: "Query executed.", // Simplified message
        resultPayload: processResult,
        timestamp: new Date(),
      }
    ]);
    setShowNewChatButton(true);
  } catch {
    setMessages(prev => [
      ...prev,
      {
        sender: 'bot',
        text: 'Could not process query. Please try again.',
        timestamp: new Date()
      }
    ]);
  }
  setIsThinking(false);
  setShowNewChatButton(true);
};






const handleNewChat = () => {
  setMessages([{
    sender: 'bot',
    text: "Welcome! I'm your dedicated Network Query Agent. Ask about network status, uptime, or alerts.",
    timestamp: new Date(),
  }]);
  setInput(""); 
  setShowNewChatButton(false); 
  
};


  const handleRefresh = () => {
    setMessages(msgs => [
      ...msgs,
      {
        sender: 'bot',
        text: "Data refreshed. Up-to-date network status loaded.",
        timestamp: new Date()
      }
    ]);
  };

  return (
    <div className={styles.chatbotRoot}>
      <div className={styles.headerBar}>
        <div className={styles.headerStart}>
          <div className={styles.iconWrap}>
            <AutoAwesomeIcon className={styles.headerIcon} />
          </div>
          <div className={styles.headerText}>
            <span className={styles.botTitle}>Network Query Agent</span>
            <span className={styles.botSubtitle}>
              AI-Powered Analytics
            </span>
          </div>
        </div>
        <div className={styles.headerActions}>
          <Chip
            className={styles.lastUpdatedChip}
            label="Last updated 1 hr ago"
            color="default"
            size="small"
            variant="outlined"
          />
           <Tooltip title="New Chat">
          <IconButton
            className={styles.iconBtn}
            aria-label="New Chat"
            size="small"
            onClick={handleNewChat}
          >
            <ChatBubbleOutlineIcon fontSize="medium" />
          </IconButton>
          </Tooltip>
          {/* <Tooltip title="refresh">
          <IconButton
            className={styles.iconBtn}
            aria-label="Refresh"
            size="small"
            onClick={handleRefresh}
          >
            <RefreshIcon fontSize="medium" />
          </IconButton>
          </Tooltip> */}
    
        </div>
      </div>

      <div className={styles.chatBody} ref={chatBodyRef}>
      {messages.map((m, i) => {
       
  const isBot = m.sender === 'bot';
  const isExpanded = expandedIndexes.includes(i);

  return isBot ? (
    <Accordion
  key={i}
    expanded={expandedIndexes.includes(i) || i === messages.length - 1}
  onChange={() =>
    setExpandedIndexes(prev =>
      prev.includes(i) ? prev.filter(idx => idx !== i) : [...prev, i]
    )
  }
  className={styles.bubbleAccordion}
  elevation={0}
  disableGutters
  square
>
<AccordionSummary
  expandIcon={<ExpandMoreIcon />}
  className={styles.bubbleAccordionSummary}
>
 
  {showAgentBadgeIdx === i && (
    <span className={`${styles.agentBadge} ${styles.agentBadgeTopLeft}`}>
      
      <span className={styles.agentBadgeText}>Intent Agent</span>
      <CheckCircleIcon className={styles.agentBadgeCheck} />
    </span>
  )}
  <span className={styles.timestamp}>
    {m.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
  </span>

{/* <div className={styles.msgText}>
  {isExpanded
    ? ""
    : "This response was generated by the Network Query Agent, your assistant for Ask about network status, uptime, or alerts.."
  }
</div> */}


</AccordionSummary>



<AccordionDetails className={styles.bubbleAccordionDetails} style={{ background: 'none', padding: 0 }}>
  <div className={styles.expandedMsgBubble}>
   
   
    

    {m.resultPayload
      ? <BotResultView result={m.resultPayload} />
      : <div className={styles.msgText}>{m.text}</div>
    }


 {m.recommendationStep && m.circuits && (
  <Box
    className={styles.bubbleText}
    sx={{
      background: "#f6fbff",
      borderRadius: 2,
      boxShadow: "0 0 0.5rem #e8f2fb",
      minWidth: 340,
      width: "100%",
      p: 2.5,
      mt: 1,
      mb: 1,
      display: "flex",
      flexDirection: "column"
    }}
  >
   
    <Autocomplete
      options={alphaSort([...new Set(m.circuits.map(c => c.location))])}
      value={selectedCircuitLocation || null}
      onChange={(e, value) => {
        setSelectedCircuitLocation(value || "");
        setSelectedCircuitVendor("");
        setSelectedCircuitId("");
        setSelectedQuarter("");
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label="Select Location"
          variant="outlined"
          size="medium"
          sx={{
            background: "#fff",
            borderRadius: 1,
            fontWeight: 500,
            mb: selectedCircuitLocation ? 2 : 0,
            '& .MuiOutlinedInput-root': { borderRadius: 1 },
            '& .MuiInputLabel-root': { color: "#7c8da0", fontSize: 16 }
          }}
          InputLabelProps={{
            style: { color: "#7c8da0", fontWeight: 600, fontSize: 16 }
          }}
          placeholder="Type to search…"
        />
      )}
      sx={{ width: '100%', mb: 2 }}
    />

   
    {selectedCircuitLocation && (
      <Autocomplete
        options={alphaSort([
          ...new Set(
            m.circuits
              .filter(c => c.location === selectedCircuitLocation)
              .map(c => c.vendor)
          ),
        ])}
        value={selectedCircuitVendor || null}
        onChange={(e, value) => {
          setSelectedCircuitVendor(value || "");
          setSelectedCircuitId("");
          setSelectedQuarter("");
        }}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            label="Select Vendor"
            variant="outlined"
            size="medium"
            sx={{
              background: "#fff",
              borderRadius: 1,
              fontWeight: 500,
              mb: selectedCircuitVendor ? 2 : 0,
              '& .MuiOutlinedInput-root': { borderRadius: 1 },
              '& .MuiInputLabel-root': { color: "#7c8da0", fontSize: 16 }
            }}
            InputLabelProps={{
              style: { color: "#7c8da0", fontWeight: 600, fontSize: 16 }
            }}
            placeholder="Type to search…"
          />
        )}
        sx={{ width: '100%', mb: 2 }}
      />
    )}

  
    {selectedCircuitLocation && selectedCircuitVendor && (
      <Autocomplete
        options={alphaSort(
          m.circuits
            .filter(
              c =>
                c.location === selectedCircuitLocation &&
                c.vendor === selectedCircuitVendor
            )
            .map(c => c.circuit_id)
        )}
        value={selectedCircuitId || null}
        onChange={(e, value) => {
          setSelectedCircuitId(value || "");
          setSelectedQuarter("");
        }}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            label="Select Circuit ID"
            variant="outlined"
            size="medium"
            sx={{
              background: "#fff",
              borderRadius: 1,
              fontWeight: 500,
              mb: selectedCircuitId ? 2 : 0,
              '& .MuiOutlinedInput-root': { borderRadius: 1 },
              '& .MuiInputLabel-root': { color: "#7c8da0", fontSize: 16 }
            }}
            InputLabelProps={{
              style: { color: "#7c8da0", fontWeight: 600, fontSize: 16 }
            }}
            placeholder="Type to search…"
          />
        )}
        sx={{ width: '100%', mb: 2 }}
      />
    )}

   
    {selectedCircuitLocation && selectedCircuitVendor && selectedCircuitId && (
      <Autocomplete
        options={alphaSort(
          quarters.map(q =>
            `${q.label} (${q.start.toLocaleDateString()} - ${q.end.toLocaleDateString()})`
          )
        )}
        value={selectedQuarter || null}
        onChange={(e, value) => setSelectedQuarter(value || "")}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            label="Select Quarter"
            variant="outlined"
            size="medium"
            sx={{
              background: "#fff",
              borderRadius: 1,
              fontWeight: 500,
              mb: 2,
              '& .MuiOutlinedInput-root': { borderRadius: 1 },
              '& .MuiInputLabel-root': { color: "#7c8da0", fontSize: 16 }
            }}
            InputLabelProps={{
              style: { color: "#7c8da0", fontWeight: 600, fontSize: 16 }
            }}
            placeholder="Type to search…"
          />
        )}
        sx={{ width: '100%', mb: 2 }}
      />
    )}

  
    <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end", mt: 1 }}>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        disabled={
          !selectedCircuitLocation ||
          !selectedCircuitVendor ||
          !selectedCircuitId ||
          !selectedQuarter
        }
        sx={{
          borderRadius: 1,
          fontWeight: 700,
          textTransform: "none",
          minWidth: 170,
          letterSpacing: 0.2,
          background: !(selectedCircuitLocation && selectedCircuitVendor && selectedCircuitId && selectedQuarter) ? "#c7ccdb" : "#b5bed1",
          color: "#fff",
          boxShadow: "none",
          fontSize: 15,
          '&:hover': {
            background: "#083ef0ff",
            color: "#fff",
            boxShadow: "none"
          },
          opacity: !(selectedCircuitLocation && selectedCircuitVendor && selectedCircuitId && selectedQuarter) ? 0.7 : 1
        }}
        onClick={async () => {
          const qObj = quarters.find(q =>
            `${q.label} (${q.start.toLocaleDateString()} - ${q.end.toLocaleDateString()})` === selectedQuarter
          );
          if (!qObj) return;
          const startDate = Math.floor(qObj.start.getTime() / 1000);
          const endDate = Math.floor(qObj.end.getTime() / 1000);
          setIsThinking(true);
          try {
            const result = await analyzeBandwidth({
              location: selectedCircuitLocation,
              customer: String(customerId),
              circuitId: selectedCircuitId,
              startDate,
              endDate,
              responseFormat: "base64",
              authKey: authToken
            });
            setMessages(m => [
              ...m,
              {
                sender: "bot",
                text: "Bandwidth Analysis Result",
                resultPayload: result,
                timestamp: new Date()
              }
            ]);
            setShowNewChatButton(true);
          } catch (err) {
            setMessages(m => [
              ...m,
              {
                sender: "bot",
                text: `Bandwidth analysis failed: ${err.message}`,
                timestamp: new Date()
              }
            ]);
            setShowNewChatButton(true);
          } finally {
            setIsThinking(false);
            setSelectedCircuitLocation("");
            setSelectedCircuitVendor("");
            setSelectedCircuitId("");
            setSelectedQuarter("");
          }
        }}
      >
        Confirm Selection
      </Button>
    </Box>
  </Box>
)}




{m.resultPayload && (
  <div>
    {/* AI Analysis Text */}
    {m.resultPayload.ai_analysis && (
      <pre
        style={{
          background: "#f6fafc",
          whiteSpace: "pre-wrap",
          fontFamily: "inherit",
          fontSize: 15,
          margin: "10px 0 18px 0",
          padding: "10px 15px",
          borderRadius: 12,
          border: "1px solid #e0ecf9",
          color: "#333"
        }}
      >
        {m.resultPayload.ai_analysis}
      </pre>
    )}
    {/* Graphs */}
    {Array.isArray(m.resultPayload.graphs) && m.resultPayload.graphs.length > 0 && (
      <div style={{ display: "grid", gap: 14, marginBottom: 12 }}>
        {m.resultPayload.graphs.map((graph, idx) =>
          graph.base64 ? (
            <img
              key={idx}
              src={`data:image/png;base64,${graph.base64}`}
              alt={`Analysis chart ${idx + 1}`}
              style={{ maxWidth: "100%", borderRadius: 10, border: "1px solid #e0ecf9", background: "#fff" }}
            />
          ) : null
        )}
      </div>
    )}
  </div>
)}


   
    {!!m.selectedLocations?.length && (
      <div style={{ marginBottom: 8 }}>
        <Chip label={`Location: ${m.selectedLocations.join(", ")}`} color="primary" size="small" />
      </div>
    )}
    {!!m.selectedVendors?.length && (
      <div style={{ marginBottom: 8 }}>
        <Chip label={`Vendor: ${Array.isArray(m.selectedVendors) ? m.selectedVendors.join(", ") : m.selectedVendors}`} color="primary" size="small" />
      </div>
    )}
    {m.selectedTimePeriod && (
      <div style={{ marginBottom: 8 }}>
        <Chip label={`Time Period: ${m.selectedTimePeriod}`} color="primary" size="small" />
      </div>
    )}

   
    {m.paramOptions?.location && (
 
    <LocationSelector
  locations={Array.isArray(m.paramOptions.location) ? m.paramOptions.location : []}
  onSelect={selected => {
    const locationList = Array.isArray(m.paramOptions.location) ? m.paramOptions.location : [];
    let value;
  
    if (selected.length === locationList.length && locationList.length > 0) {
      value = "all";
    } else {
      value = selected.join(",");
    }
    handleParamSelection(m, "location", value);
  }}
/>

    )}
    {m.paramOptions?.vendor && (
      <VendorSelector
        vendors={Array.isArray(m.paramOptions.vendor) ? m.paramOptions.vendor : []}
        onSelect={val => handleParamSelection(m, "vendor", val)}
      />
    )}
    {m.paramOptions?.time_period && (
      <TimePeriodSelector
        onSelect={val => handleParamSelection(m, "time_period", val)}
      />
    )}

   <div className={styles.botActions}>
  <Tooltip title="Copy">
    <IconButton
      size="small"
      className={styles.actionIconBtn}
      onClick={() => navigator.clipboard.writeText(m.text)}
    >
      <ContentCopyIcon fontSize="small" />
    </IconButton>
  </Tooltip>

  <Tooltip title="Good response">
    <IconButton
      size="small"
      className={styles.actionIconBtn}
      onClick={async () => {
        try {
          await sendFeedback({
             feedbackType: 'correct',
  userInput: 'give me best perfroming link',
  enhancedQuery:'give me best perfroming link for mumbai',
  aiSqlQuery: m.resultPayload.gemini.query || '',
  feedbackText: 'good result',
  authToken
          });
        } catch (err) {
          // Optionally handle API error/display status
        }
      }}
    >
      <ThumbUpAltOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>

  <Tooltip title="Bad response">
    <IconButton
      size="small"
      className={styles.actionIconBtn}
      onClick={async () => {
        try {
          await sendFeedback({
             feedbackType: 'wrong',
  userInput: "give worst perfroming links",
  enhancedQuery: 'give  worst perfoming links for mumbai',
  aiSqlQuery: m.resultPayload.gemini.query || '',
  feedbackText: 'bad result',
  authToken
          });
        } catch (err) {
          // Optionally handle API error/display status
        }
      }}
    >
      <ThumbDownAltOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
</div>

  </div>
</AccordionDetails>
</Accordion>

  ) : (
    <div key={i} className={styles.userMsg}>
      <div className={styles.msgText}>{m.text}</div>
      <span className={styles.timestamp}>
        {m.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </span>
    </div>
  );
})}

 {isThinking && (
    <div className={styles.thinkingBubble}>
      <span className={styles.thinkingText}>Thinking...</span>
       <CircularProgress
        size={19}
        thickness={5}
        variant="indeterminate"
        className={styles.agentBadgeSpinner}
      />
       
    </div>
  )}

      </div>

    <div className={styles.inputSection}>
  {!showNewChatButton ? (
    <>
      <form className={styles.inputArea} onSubmit={handleSend}>
        <textarea
          className={styles.inputBox}
          placeholder="Ask about network performance, best performing links, alerts, or any monitoring queries…"
          value={input}
          onChange={e => {
            if (e.target.value.length <= 2000) setInput(e.target.value);
          }}
          maxLength={2000}
          rows={1}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend(e);
            }
          }}
        />
        <button
          className={styles.sendBtn}
          type="submit"
          title="Send"
          disabled={input.trim().length === 0}
        >
          Send
          <span className={styles.sendIcon}>
            <svg height="22" width="22" viewBox="0 0 24 24" fill="none">
              <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z" fill="currentColor"/>
            </svg>
          </span>
        </button>
      </form>
      <div className={styles.inputFooter}>
        <div className={styles.inputHints}>
          Press <b>Enter</b> to send&nbsp;&nbsp;
          Press <b>Shift + Enter</b> for new line&nbsp;&nbsp;
          Press <b>Ctrl + K</b> for commands
        </div>
        <div className={styles.inputMeta}>
          <span className={styles.charCountFooter}>{input.length}/2000</span>
          <span className={styles.statusConnected}>Connected</span>
        </div>
      </div>
    </>
  ) : (
    <div className={styles.inputAreaSend} style={{ justifyContent: "center" }}>
      {/* <button
  className={styles.sendBtn}
  type="button"
  onClick={() => {
    setShowNewChatButton(false);
    setInput("");
    setMessages([
      {
        sender: "bot",
        text: "Welcome! I'm your dedicated Network Query Agent. Ask about network status, uptime, or alerts.",
        timestamp: new Date(),
      }
    ]);
    
  }}
>
  Start New Chat
</button> */}
<button
  className={styles.sendBtn}
  type="button"
  onClick={() => window.location.reload()}
>
  Start New Chat
</button>

    </div>
  )}
</div>

    </div>
  );
};

export default AiChatBot;
